import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import extendedFieldInputContainers from "../containers";

const { IconContainer } = extendedFieldInputContainers;

const IncludeYear = () => {
  const [includeYear, setIncludeYear] = extendedFieldHooks.useIncludeYear();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();

  const handleSetIncludeYear = () => setIncludeYear(!includeYear);

  return (
    <FnrCard data-cy="ExtendedFields_IncludeYear">
      <FnrHorizontalGap>
        <IconContainer $color="textSecondary">
          <FnrIcon icon="fa-calendar-alt fas" />
        </IconContainer>
        <FnrVerticalGap gap={8}>
          <FnrTypography>Would you like to include the year?</FnrTypography>
          <FnrCheckbox
            on={includeYear}
            toggleOn={handleSetIncludeYear}
            disabled={isReadOnly}
            data-cy={"IncludeYear_Checkbox"}
          >
            <FnrTypography>Include Year</FnrTypography>
          </FnrCheckbox>
        </FnrVerticalGap>
      </FnrHorizontalGap>
    </FnrCard>
  );
};

export default IncludeYear;
